import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseDraggableWidget } from '../Card';

const TITLE = 'Blank Widget';
const DESCRIPTION = 'Enter description here';
const CATEGORY = 'Blank Category';

const BlankWidget = ({ title, isPreview, ...rest }) => {
	const [query, setQuery] = useState('');

	const navigate = useNavigate();

	if (isPreview) {
		return (
			<BaseDraggableWidget
				title={TITLE}
				category={CATEGORY}
				description={DESCRIPTION}
				{...rest}
				isPreview={true}
			/>
		);
	}

	return (
		<BaseDraggableWidget title={TITLE} widgetProps={{}} {...rest}>
			<>Blank widget</>
		</BaseDraggableWidget>
	);
};

export default BlankWidget;
